export const APP_NAME = 'yhfhyy_doc_bzb';
export const BOOKHOSID = '057301';
export const HOSID = '3308000001';
/**
 * 基础参数
 * @type {{channel: string, format: string, oper: string, random: string, spid: string}}
 */
export const BASE_PARAMS = {
  'channel': '4',
  'format': 'JSON',
  'oper': '127.0.0.1',
  'random': '1234',
  'spid': '1001',
  version: '1.0.0'
}

/**
 * 主题色
 * @type {string}
 */
export const MAIN_COLOR = '#00b2b1';

/**
 * 左侧背景色
 * @type {string}
 */
export const LEFT_BG = '#324157';

/**
 * 视频播放器控制按钮
 * @type {*[]}
 */
export const VIDEO_CONTROLS = [
  {
    icon: require('../../assets/icon/jingyin.fw.png'),
    icon1: require('../../assets/icon/quxiaojingyin.fw.png'),
    name: '静音',
    name1: '取消静音',
    default: 0
  },
  {
    icon: require('../../assets/icon/guaduan.png'),
    name: '挂断',
    default: 0
  },
  {
    icon: require('../../assets/icon/guanbi.fw.png'),
    icon1: require('../../assets/icon/dakai.fw.png'),
    name: '关闭视频',
    name1: '打开视频',
    default: 0
  }
]
/**
 * 续方类型
 * @type {*[]}
 */
export const RENEWAL_TYPE = [
  {name: '本院续方', id: 'INSIDE'},
  {name: '外院续方', id: 'EXTERNAL'},
]

/**
 * 慢病续方-订单状态
 * @type {*[]}
 */
export const RENEWAL_ORDER_STATUS = [
  {id: 'APPLYING', name: '申请中', desc: '请耐心等待医生处理，医生可能会联系您。'},
  {id: 'WAITPAY', name: '待支付', desc: '医生已为您续方，请尽快支付处方费用'},
  {id: 'WAITTAKE', name: '待取药', desc: '已支付费用，您可以到院取药或选择配送到家'},
  {id: 'CANCEL', name: '已取消', desc: ''},
  {id: 'CONTINUATION', name: '已续方'},
  {id: 'SHIPPING', name: '配送中', desc: '药品正在为您配送中'},
  {id: 'COMPLATE', name: '已完成', desc: '祝您健康常伴'}
];
/**
 * 网络诊间-门诊类别
 * @type {*[]}
 */
export const ONLINE_MZLB = [
  {value: '1', label: '专家门诊'},
  {value: '2', label: '普通门诊'}
]
/**
 * 网络诊间订单状态
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_DDZT = {
  '0': '候诊中',
  '3': '已取消',
  '5': '已完成'
}

/**
 * 网络诊间订单状态映射按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_DDZT_BTN = {
  '0': ['提醒进入诊间', '接诊'],
  '3': [],
  '5': ['查看资料']
}

/**
 * 网络诊间订单状态按钮
 * @type {{"0": string, "3": string, "5": string}}
 */
export const ONLINE_BTN_MAP = {
  '提醒进入诊间': {type: 'app_btn_default'},
  '接诊': {type: 'app_btn_primary'},
  '查看资料': {type: 'app_btn_default'}
}
/**
 * 慢病续方-药品类型
 * @type {{"1": string, "2": string}}
 */
export const RENEWAL_CHUFANG_TYPE = {
  '1': '西药药品',
  '2': '中药药品',
}
/**
 * 药事服务-处方类型
 * */
export const ORDER_TYPE_LIST = [
  {value:'WESTERN_RECIPE',label: '西药方'},{value:'PRESCRIPT_RECIPE',label: '成药方'},{value:'CHINESE_RECIPE',label: '草药方'}
]




